import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@one-thd/sui-atomic-components';
import React from 'react';
import {
  IPHTableHeader,
  ITableHeaderData,
} from '../../../models/purchase-history/table';
import { PHTableHeaderData } from './PHTableHeaderData';

export const PHTableHeader = ({
  orderHistoryLoaded,
  pHRequest,
  setPHRequest,
  tableHeaderState,
}: IPHTableHeader) => {
  const sortDirection = pHRequest?.sortOrder;
  const selectedHeader = pHRequest?.sortBy;

  const searchByObj = pHRequest?.searchBy?.[0] ?? {};

  const tableHeaderData = PHTableHeaderData(
    pHRequest,
    searchByObj,
    selectedHeader,
    setPHRequest,
    sortDirection,
    tableHeaderState,
  );

  const emptyHeaders: ITableHeaderData[] = [];

  return (
    <TableHead>
      <TableRow>
        {orderHistoryLoaded ? (
          <>
            <TableCell style={{ width: '65px' }}>&nbsp;</TableCell>
            {tableHeaderData?.map((header: ITableHeaderData, index: number) => {
              if (header?.showHeader === false) {
                emptyHeaders.push(header);
                return null;
              }
              if (header.sort) {
                return (
                  <TableCell
                    key={index}
                    align="left"
                    variant="head"
                    padding="none"
                    style={header?.style}
                    sortDirection={header?.sortProps?.sortDirection}
                  >
                    <TableSortLabel
                      aria-label={header?.sortProps?.ariaLabel}
                      active={header?.sortProps?.active}
                      direction={header?.sortProps?.sortDirection}
                      onClick={header?.sortProps?.onClick}
                      style={header?.sortProps?.style}
                    >
                      {header?.title}
                    </TableSortLabel>
                  </TableCell>
                );
              }
              return (
                <TableCell
                  key={index}
                  align="left"
                  variant="head"
                  padding="none"
                  style={header?.style}
                >
                  {header?.title}
                </TableCell>
              );
            })}
            {emptyHeaders?.map((header, key) => {
              if (key < 3) {
                return null;
              }
              return (
                <TableCell
                  key={key}
                  align="left"
                  variant="head"
                  padding="none"
                  style={(header as ITableHeaderData)?.style}
                >
                  <div />
                </TableCell>
              );
            })}
            <TableCell style={{ maxWidth: '36px' }}>&nbsp;</TableCell>
          </>
        ) : (
          <TableCell style={{ maxWidth: '36px' }}>&nbsp;</TableCell>
        )}
      </TableRow>
    </TableHead>
  );
};
